import { GetStaticProps } from "next";
import Head from "next/head";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { getAllPostsForHome, getAllWhitepaper } from "../../lib/api";
import Layout from "../../components/layout";
import BlogHeroSectionV2 from "../../components//v2/blog/blog-hero";
import { useRouter } from "next/router";
import BlogArchive from "../../templates/blog-archieves";
import Custom404 from "../404";
import BlogLatestPost from "../../components/v2/blog/lastest-post";
import CallToActionBlog from "../../components/v2/blog/call-to-action-blog";
import MwBlogs from "../../components/v2/blog/hero-section_tabs";
import {
  CustomerStoryHexa,
  ProductUpdateHexa,
  WhitepaperHexa
} from "../../components/v2/icons";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import Link from "../../components/Link";
import parse from "html-react-parser";
import dayjs from "dayjs";
import CallToActionBlogBottom from "../../components/v2/call-to-action-blog-bottom";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18nextConfig from "../../next-i18next.config";
import { useTranslation } from "next-i18next";
import { mwImage } from "../../lib/common";
import "../../styles/scss/blog.module.scss";

export default function Index({
  allPosts,
  preview,
  allWhitepaper,
  totalPosts,
  postPerPage,
}) {
  const router = useRouter();
  const { t } = useTranslation('common');
  const blogCards = t('blog.cards', { returnObjects: true, defaultValue: {} }) as any;
  const { edges } = allPosts;
  const [pageNum, setPageNum] = useState<number | null>(null);
  const isNumeric = (value: any) => /^\d+$/.test(value);

  useEffect(() => {
    if (router.isReady) {
      const { page } = router.query;
      let pageNumber: number | null = null;
      if (Array.isArray(page)) {
        pageNumber = parseInt(page[0], 10);
      } else if (page) {
        pageNumber = parseInt(page, 10);
      }

      setPageNum(pageNumber);
    }
  }, [router.isReady, router.query]);

  useEffect(() => {}, [pageNum]);

  if (pageNum !== null && pageNum > Math.ceil(totalPosts / postPerPage)) {
    return <Custom404 />;
  }

  const heroPost = [edges[0]];
  const morePosts = edges.slice(1, 5);
  const allowedDatabaseIds = [456, 1648, 5701];
  const trendingPost = edges.filter(({ node }) =>
    allowedDatabaseIds.includes(node.databaseId),
  );

  const productUpdates = edges
    .filter(({ node }) =>
      node.categories.nodes.some(
        (category) => category.name === "Product updates",
      ),
    )
    .slice(0, 4);
  const belowPost = edges.slice(1, 13);

  const heroImageUrl = edges?.[0]?.node?.featuredImage?.node?.sourceUrl
    ? mwImage(edges[0].node.featuredImage.node.sourceUrl)
    : null;

  if (pageNum === null || !isNumeric(pageNum)) {
    return (
      <>
        {heroImageUrl && (
          <Head>
            <link
              rel="preload"
              as="image"
              href={heroImageUrl}
              fetchPriority="high"
            />
          </Head>
        )}
      <Layout
        isHomePage={false}
        pageTitle={"blog-home"}
        ogImage={null}
        metaTitle={"Observability News, and Best Practices and Guides"}
        metaDesc={
          "Read how observability can scale your cloud infrastructure, best practices, how-tos guide and industry updates from experts."
        }
        uri={"/blog/"}
        metaRobotsNoindex={"index"}
        metaRobotsNofollow={"follow"}
      >
        <div className={"middle-wrapper site-page blog-v2 "}>
          <div className={"blog-main-page"}>
            <MwBlogs searchInputPostDetails={edges} />
            <BlogHeroSectionV2 leftBlockPostDetails={heroPost} firstImageIsLcp />
            <BlogLatestPost latestPost={trendingPost} />
            <CallToActionBlog
              title={t('blog.newsletter.title') || "No spam, Get the latest Observability insights in your inbox"}
            />

            <section className={"all-blogs-show site-page all-blogs-v2"}>
              <div className={"container"}>
                <div className={"section-tag news"}>Latest Blogs 📖</div>
                <div className={"content-container"}>
                  <div className={"content-wrapper"}>
                    <div className={"d-flex"}>
                      {belowPost.map((__post) => {
                        const post = __post.node;
                        const title = post.title;
                        let link = post.slug;
                        if (
                          post?.parentSlug?.parentSlug != null &&
                          post?.parentSlug?.parentSlug.length > 0
                        ) {
                          link = `${post?.parentSlug?.parentSlug}`;
                        }

                        return (
                          <div className={"inner-block"} key={post.uri}>
                            <Link href={`/blog/${link}`} itemProp="url">
                              {" "}
                              <div className={"image-wrapper"}>
                                <Image
                                  src={mwImage(post?.featuredImage?.node?.sourceUrl)}
                                  alt={title}
                                  width={400}
                                  height={250}
                                  loading="lazy"
                                  unoptimized
                                  sizes="(max-width: 768px) 100vw, 400px"
                                />
                              </div>
                            </Link>
                            <div>
                              <Link
                                href={
                                  "/blog/category/" +
                                  post.categories.nodes[0].slug +
                                  "/"
                                }
                              >
                                <div
                                  className={`category ${post.categories.nodes[0].slug}`}
                                  key={post.uri}
                                >
                                  {post.categories.nodes[0].name}
                                </div>
                              </Link>
                              <div key={post.uri}>
                                <article
                                  className="post-list-item"
                                  itemScope
                                  itemType="http://schema.org/Article"
                                >
                                  <header>
                                    <Link href={`/blog/${link}`} itemProp="url">
                                      <h4>{parse(title)}</h4>
                                    </Link>
                                    <div className={"date-time"}>
                                      {dayjs(post?.date).format("D MMM YYYY")}
                                    </div>
                                  </header>
                                </article>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className={"button-view-all-post"}>
                      <Link href={"/blog/?page=1"}>
                        <button className="view-more-btn">
                          View All Blogs
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section className={"mw-card-with-icon blog-page"}>
            <div className={"container"}>
              <div className={"card-items"}>
                <div className={"d-flex card-items"}>
                  <CardWithIcon
                    icon={<WhitepaperHexa />}
                    title={blogCards?.whitepaper?.title || "Whitepaper"}
                    description={blogCards?.whitepaper?.description || "Comprehensive Insights and Solutions: Your Guide to Informed Decision-Making."}
                    link={"/whitepaper/"}
                  />
                  <CardWithIcon
                    icon={<CustomerStoryHexa />}
                    title={blogCards?.customerStories?.title || "Customer Stories"}
                    description={blogCards?.customerStories?.description || "Expert Insights and Solutions: Your Guide to Smarter Decisions."}
                    link={"/customers/"}
                  />
                  <CardWithIcon
                    icon={<ProductUpdateHexa />}
                    title={blogCards?.productUpdate?.title || "Product Update"}
                    description={blogCards?.productUpdate?.description || "Latest Innovations and Enhancements: Your Guide to Product Excellence."}
                    link={"/product-updates/"}
                  />
                </div>
              </div>
            </div>
          </section>

          <CallToActionBlogBottom />
        </div>
      </Layout>
      </>
    );
  } else {
    return (
      <BlogArchive
        allPostData={allPosts}
        totalPosts={totalPosts}
        postPerPage={postPerPage}
        currentPage={pageNum}
        uri={`/blog/?page=${pageNum}`}
        nextPagePath={`/blog/?page=${pageNum + 1}`}
        prevPagePath={`/blog/?page=${pageNum - 1}`}
      />
    );
  }
}

export const getStaticProps: GetStaticProps = async (ctx) => {
//   const i18nProps = await getI18nProps(ctx, ["common"]);
  // Next.js i18n automatically generates pages for all locales configured in next.config.js
  // The locale is passed in ctx.locale for each generated page
  const locale = (ctx?.locale as string) ?? "en";
  const allPosts = await getAllPostsForHome(false, locale);
  const allWhitepaper = await getAllWhitepaper();
  const totalPosts = allPosts.edges.length;
  const postPerPage = 12;
  const translations = await serverSideTranslations(
    locale,
    ["common", "header", "footer"],
    nextI18nextConfig,
  );

  return {
    props: {
      ...translations,
    //   ...i18nProps,
      allPosts,
      preview: false,
      allWhitepaper,
      totalPosts,
      postPerPage,
      pageTitle: "Observability Blogs | Middleware",
      description:
        "Stay updated on observability best practices, guides, and industry news. Dive deep into our solutions, integration techniques, and trends on our blog.",
      ogImage: null,
      uri: "/blog/",
      metaTitle: "Observability Blogs | Middleware",
      metaDesc:
        "Stay updated on observability best practices, guides, and industry news. Dive deep into our solutions, integration techniques, and trends on our blog.",
      metaRobotsNoindex: "index",
      metaRobotsNofollow: "follow",
    },
  };
};
